<template>
  <div class="select-exam-wrap">
    <Header></Header>
    <div class="top">
      <div>
        <p style="font-size: 18px; font-weight: bold;">{{ detailObj.ExamPaperName }}</p>
        <p style="margin: 20px 0;"><span>考试时长：{{detailObj.TotalExamTime}}分钟</span><span>总分：{{detailObj.TotalScore}}分</span><span>合格分数：{{detailObj.PassMark}}分</span></p>
      </div>
      <div>
        <el-button type="primary" @click="pathTo">进入考试</el-button>
      </div>
    </div>
    <div class="main">
      <el-table :data="detailObj.ExamRecordList" border :height="tableHeight" style="width: 100%" :header-cell-style="{background:'#eef1f6',color:'#606266'}" :row-class-name="tableRowClassName">
        <el-table-column align="center" prop="ExamUserAccount" label="用户名" width="180">
        </el-table-column>
        <el-table-column align="center" prop="TotalScore" label="分数" width="180">
        </el-table-column>
        <el-table-column align="center" prop="EndTime" label="考试用时">
          <template slot-scope="scope">
            <span>{{ Math.ceil((new Date(scope.row.EndTime).getTime()-new Date(scope.row.StartTime).getTime())/60000) }}分钟</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="StartTime" label="考试时间">
          <template slot-scope="scope">
            {{scope.row.StartTime.slice(0,10)}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="RankNo" label="名次">
          <template slot-scope="scope">
            {{ scope.row.RankNo }}/{{detailObj.ExamRecordList.length}}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import  Header  from '@/components/Header.vue'
export default {
  name: 'SelectExam',
  components:{
    Header
  },
  data() {
    return {
      detailObj:{}    
    }
  },
  computed:{
    tableHeight(){
      return document.body.scrollHeight-205
    }
  },
  mounted(){
    this.$api.HJGetExamPaperById({ paperId:this.$route.query.examID }).then(res => {
        if (res.Success) {
          this.detailObj = res.Data;
        } else this.$message.error(res.Msg)
      })
  },
  methods: {
    //table给指定行家背景色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return 'success-row';
      }
      return '';
    },
    //考试模式跳转
    pathTo(){
      console.log(this.detailObj )
      if(this.detailObj.ExamCategoryId===1){
        this.$router.push({
          path:'GuidePage',
          query:{
            examID:this.$route.query.examID
          }
        })
      }else{
        this.$router.push({
          path:'StartExam',
          query:{
            examID:this.$route.query.examID
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-exam-wrap {
  padding-top: 86px;
  height: calc(100% - 5px);
  overflow: hidden;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    margin: 10px auto;
    span {
      margin-right: 40px;
    }
  }
  .main {
    align-items: center;
    width: 100%;
    max-width: 1200px;
    margin: 10px auto;
    ::v-deep .success-row {
      background-color: #f0f9eb !important;
    }
  }
}
</style>